import { render, staticRenderFns } from "./maintenanceDetail.vue?vue&type=template&id=68db1db5&scoped=true&"
import script from "./maintenanceDetail.vue?vue&type=script&lang=js&"
export * from "./maintenanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceDetail.vue?vue&type=style&index=0&id=68db1db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db1db5",
  null
  
)

export default component.exports